import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const YoutubeVideoDescription = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14934)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#FEF2F2"
          />
          <path
            d="M137.948 96.9033H96.0043L72.0364 114.879V96.9033H60.0525C56.8568 96.9033 54.0605 94.1073 54.0605 90.9112V30.992C54.0605 27.7962 56.8568 25 60.0525 25H137.948C141.144 25 143.94 27.7962 143.94 30.992V90.9112C143.94 94.1073 141.144 96.9033 137.948 96.9033Z"
            fill="white"
            stroke="black"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="63"
            y="61.9395"
            width="77"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="63"
            y="69.9395"
            width="61"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="63"
            y="77.9395"
            width="43"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <circle
            cx="67"
            cy="38.9395"
            r="4"
            fill="#1E1E1E"
          />
          <rect
            x="75"
            y="36.9395"
            width="38"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="117"
            y="36.9395"
            width="20"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <path
            d="M117.353 108.171H147.821L165.232 121.229V108.171H173.937C176.258 108.171 178.29 106.14 178.29 103.818V60.2921C178.29 57.9707 176.258 55.9395 173.937 55.9395H117.353C115.031 55.9395 113 57.9707 113 60.2921V103.818C113 106.14 115.031 108.171 117.353 108.171Z"
            fill="white"
            stroke="black"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M142.85 94.8853C143.983 96.1109 145.914 96.1302 147.072 94.9274L159.738 81.7648C162.349 79.1532 162.929 75.0908 161.479 71.6086C158.867 66.3855 151.613 65.2248 147.55 69.2872L145.229 71.6086L142.907 69.2872C138.555 64.9346 131.59 66.0953 128.979 71.6086C127.238 75.0908 127.818 79.1532 130.72 81.7648L142.85 94.8853Z"
            fill="#FF5A4F"
            stroke="black"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M144 50.9395H54V48.9395H144V50.9395Z"
            fill="black"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            fill="white"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <path
            d="M183.991 26.5021C183.991 26.5021 174.614 26.5021 172.261 27.1136C171.001 27.4656 169.964 28.5032 169.612 29.7818C169 32.1351 169 37.0086 169 37.0086C169 37.0086 169 41.9006 169.612 44.2169C169.964 45.4954 170.983 46.5145 172.261 46.8665C174.633 47.4966 183.991 47.4966 183.991 47.4966C183.991 47.4966 193.385 47.4966 195.739 46.8851C197.017 46.533 198.036 45.5325 198.37 44.2354C199 41.9006 199 37.0271 199 37.0271C199 37.0271 199.018 32.1351 198.37 29.7818C198.036 28.5032 197.017 27.4842 195.739 27.1507C193.385 26.5021 183.991 26.5021 183.991 26.5021ZM181.007 32.5059L188.809 37.0086L181.007 41.4928V32.5059Z"
            fill="#FF0000"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14934">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
YoutubeVideoDescription.displayName = 'YoutubeVideoDescription';
